const checkHorizontalScrollElements = document.querySelectorAll('[vdx-gsap-horizontalscroll]');

if (checkHorizontalScrollElements.length > 0){
    if (typeof gsap === 'undefined') {
        console.log('🚨 GSAP is missing! Please turn on GSAP in Webflow for the magic to happen! ✨');
    }
    if (typeof ScrollTrigger === 'undefined') {
        console.log('📜 ScrollTrigger not found! Your animations need this awesome plugin - activate it in Webflow! 🔥');
    }
}

if (checkHorizontalScrollElements.length > 0 && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined'){
    gsap.registerPlugin(ScrollTrigger);
}

export const horizontalScroll = () => {
    if (checkHorizontalScrollElements.length > 0 && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined'){
        const horizontalScrollElements = gsap.utils.toArray('[vdx-gsap-horizontalscroll]');
        if (horizontalScrollElements.length === 0) {
            return; 
        }
        horizontalScrollElements.forEach(container => {
            if (container && container.children && container.children.length > 1) {
                gsap.to(Array.from(container.children), {
                    xPercent: -100 * (container.children.length - 1),
                scrollTrigger: {
                    trigger: container,
                    pin: true,
                    scrub: 3, // Increased from 1 to 3 to slow down the scrolling
                    end: "+=400", // Extend the scrolling distance to slow down the progression
                }
            });
        }
    
    });
    }
}